import React, { forwardRef } from 'react';
import { useMapImageActions } from '../hooks/useMapImageActions';
import { MapControlMenu } from './MapControlMenu';
import { MapControlMenuOption } from './MapControlMenuOption';

const MapImageMenu = forwardRef<HTMLButtonElement>((_, ref) => {
    const { copyMapImage, saveMapImage, copyStatus, resetCopyStatus } =
        useMapImageActions();

    return (
        <>
            <MapControlMenu
                ref={ref}
                id="map-image-actions"
                label="Ta kartbilde"
                icon={
                    <i
                        className="material-icons c-map-control-menu__toggle-icon"
                        aria-hidden="true"
                    >
                        screenshot_monitor
                    </i>
                }
                onToggle={resetCopyStatus}
            >
                <MapControlMenuOption
                    label={
                        copyStatus === 'copying'
                            ? 'Kopierer...'
                            : copyStatus === 'copied'
                              ? 'Kopiert!'
                              : 'Kopier'
                    }
                    active={false}
                    iconName="o-icon-copy"
                    onClick={() => {
                        void copyMapImage();
                    }}
                />
                <MapControlMenuOption
                    label="Lagre"
                    active={false}
                    iconName="o-icon-download"
                    onClick={() => {
                        void saveMapImage();
                    }}
                />
            </MapControlMenu>
            <span className="sr-only" role="status">
                {copyStatus === 'copied' && 'Kartbildet er kopiert til utklippstavlen.'}
            </span>
        </>
    );
});

MapImageMenu.displayName = 'MapImageMenu';
export { MapImageMenu };
